import React from 'react';
import PropTypes from "prop-types";
import './PageHeader.less';
import {CrownOutlined, DeploymentUnitOutlined, PoweroffOutlined} from "@ant-design/icons";
import {Button, Tooltip} from "antd";
import SData from "../../helpers/SData";
import TimeLogic from "../../helpers/TimeLogic";

class PageHeader extends React.PureComponent {

    updateInterval = null;

    constructor(props, context) {
        super(props, context);
    }

    componentDidMount() {
        this.removeUpdater();
        this.updateInterval = setInterval(() => this.forceUpdate(), 1500);
    }

    componentWillUnmount() {
        this.removeUpdater();
    }

    removeUpdater = () => {
        if (this.updateInterval != null){
            clearInterval(this.updateInterval);
            this.updateInterval = null;
        }
    }

    getCurrentTime = () => {
        let date = TimeLogic.getDate();
        return date.getHours() + ':' + ('0' + date.getMinutes()).substr(-2).toString();
    }

    renderWorkState = () => {
        let color = 'blue';
        let text = <>Вы свободны</>;
        switch (SData.base.status){
            case 1:
                color = 'orange';
                text = <>В работе</>;
                break;
            case 2:
                color = 'red';
                text = <>На перерыве</>;
                break;
        }
        return <div className={'workState ' + color}>
            <div className='center'>{text}</div>
        </div>;
    }

    render() {
        return (
            <div className={'PageHeader'}>
                <div className='PageHeaderContent'>
                    <div className='PageHeaderTitle'>{this.props.title}</div>
                    <div className='PageHeaderStates'>
                        {this.renderWorkState()}
                    </div>
                </div>
                <div className='PageHeaderRight'>
                    <div className='PageHeaderPoints'>
                        <Tooltip className='container' placement="bottomLeft" title='Ваш баланс поинтов'>
                            <CrownOutlined/>
                            <div className='value'>{SData.base.points}</div>
                        </Tooltip>
                    </div>
                    <div className='PageHeaderScores'>
                        <Tooltip className='container' placement="bottom" title='Ваш баланс баллов'>
                            <DeploymentUnitOutlined/>
                            <div className='value'>{SData.base.scores}</div>
                        </Tooltip>
                    </div>
                    <div className='PageHeaderTime'>
                        <Tooltip className='container' placement="bottomRight" title='Текущее время'>
                            {this.getCurrentTime()}
                        </Tooltip>
                    </div>
                </div>
            </div>
        );
    }
}

PageHeader.propTypes = {
    title: PropTypes.string.isRequired,
    right: PropTypes.element,
    statusUser: PropTypes.number,
};
PageHeader.defaultProps = {}

export default PageHeader;